/* @flow */

import Honeybadger from 'honeybadger-js';
import { retrieve } from 'putki';
import actionEntryPoints from './actionEntryPoints';
import $ from 'jquery';

function buildModuleName(controller, action) {
  const camelCaseController = controller.replace(/(_\w)/g, match =>
    match[1].toUpperCase()
  );
  const upcaseAction = action.replace(/^./, match => match.toUpperCase());
  return `${camelCaseController}${upcaseAction}`;
}

function actionAlias(action) {
  const crudAliases = {
    update: 'edit',
    create: 'new'
  };
  return crudAliases[action] || action;
}

function findScript(controller, action) {
  const moduleNameWithAction = buildModuleName(controller, actionAlias(action));
  const moduleNameWithoutAction = buildModuleName(controller, '');

  if (typeof actionEntryPoints[moduleNameWithAction] === 'function') {
    const actionFunc = actionEntryPoints[moduleNameWithAction];
    return actionFunc();
  }

  if (typeof actionEntryPoints[moduleNameWithoutAction] === 'function') {
    const actionFunc = actionEntryPoints[moduleNameWithoutAction];
    return actionFunc();
  }

  return Promise.resolve({ default: () => {} });
}

const controller = retrieve('controller');
const action = retrieve('action');

if (typeof controller === 'string' && typeof action === 'string') {
  findScript(controller, action)
    .then(module => module.default)
    .then(initializer => {
      $(document).ready(Honeybadger.wrap(initializer));
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.error(err);
    });
}
